import Nav from "@/components/Nav";
import Experience from "@/components/Experience";
import Credentials from "@/components/Credentials";
import Languages from "@/components/Languages";
import Footer from "@/components/Footer";

export default function ExperiencePage() {
  return (
    <div data-testid="experience-page" className="bg-ivory">
      <Nav />
      <div className="pt-20">
        <Experience />
        <Credentials />
        <Languages />
      </div>
      <Footer />
    </div>
  );
}
